import { Heading, Link, Stack, Text } from '@chakra-ui/react';

export const PrivacyPt = () => {
  return (
    <div>
      <Heading as="h1" size="md" mt={4}>
        DECLARAÇÃO DE PRIVACIDADE SUP SUP CLUB
      </Heading>
      <Stack gap={4} mt={4}>
        <Text>
          Quando queres alugar uma prancha de SUP no SUP SUP CLUB, ou quando
          fazes uma encomenda através do nosso site (www.supsupclub.com),
          precisamos de alguns dados pessoais teus. Gostaríamos de te explicar
          nesta Declaração de Privacidade por que precisamos desses dados
          pessoais e o que fazemos com eles.
        </Text>
        <Text>
          SUP SUP CLUB considera a privacidade importante e está empenhado em
          proteger a privacidade dos seus Participantes. Armazenamos,
          processamos e protegemos cuidadosamente os dados pessoais. Cumprimos
          todas as obrigações decorrentes do Regulamento Geral sobre a Proteção
          de Dados (Regulamento (UE) 2016/679) (RGPD) e demais legislação de
          privacidade.
        </Text>
        <Text>
          A SUP SUP CLUB B.V. e o seu escritório estão localizados na Zandhoek
          22 (1013 KT) em Amesterdão. As suas estações de aluguer estão
          distribuídas por vários locais nos Países Baixos (consulta os
          endereços específicos no nosso site em localizações).
        </Text>
        <Heading size="md">Que dados pessoais recolhemos?</Heading>
        <ul>
          <li>nome e apelido;</li>
          <li>género;</li>
          <li>data de nascimento;</li>
          <li>endereço de e-mail;</li>
          <li>número de telefone (móvel);</li>
          <li>dados de morada;</li>
          <li>dados bancários;</li>
          <li>
            informações sobre a tua visita ao SUP SUP CLUB (horários de entrada
            e saída do aluguer de pranchas de SUP e aulas reservadas);
          </li>
          <li>dados de transação de encomendas; e</li>
          <li>
            endereços IP, sistema operativo, tipo de navegador e registos de
            data/hora.
          </li>
        </ul>
        <Text>Utilizamos estes dados para os seguintes fins:</Text>
        <ul>
          <li>elaboração, envio e preparação de faturas;</li>
          <li>fornecimento de informações;</li>
          <li>melhoria dos nossos serviços;</li>
          <li>resposta a perguntas feitas, por exemplo, através do site;</li>
          <li>
            eventual fornecimento de informações sobre novos produtos e
            serviços; e
          </li>
          <li>
            cumprimento das nossas obrigações decorrentes de contratos que
            celebrámos contigo, bem como para faturação e entrega.
          </li>
        </ul>
        <Text>
          A base para o processamento é a execução do contrato contigo e
          obrigações legais.
        </Text>
        <Heading size="md">Fornecimento de dados pessoais a terceiros</Heading>
        <Text>
          Não vendemos, negociamos nem fornecemos dados pessoais a terceiros sem
          o teu consentimento explícito. Os teus dados pessoais só serão
          partilhados se formos legalmente obrigados a fazê-lo.
        </Text>
        <Heading size="md">Subcontratantes</Heading>
        <Text>
          Para prestar os nossos serviços, recorremos a outros subcontratantes,
          como a Adyen para pagamentos. Garantimos que os nossos subcontratantes
          também processam dados pessoais de acordo com o RGPD.
        </Text>
        <Heading size="md">Os teus direitos</Heading>
        <Text>
          Tens sempre o direito de aceder aos dados pessoais que temos sobre ti.
          Se esses dados estiverem incorretos, podes ajudar-nos a corrigi-los ou
          pedir-nos que limitemos o processamento. Também tens o direito de nos
          pedir para apagar os teus dados pessoais ou para os disponibilizar num
          suporte de dados. Estes pedidos serão sempre atendidos. Podes exercer
          estes direitos enviando um e-mail para o endereço de contacto no site.
          Além disso, podes sempre opor-te ao processamento dos teus dados
          pessoais.
        </Text>
        <Heading size="md">
          Durante quanto tempo guardamos os teus dados pessoais?
        </Heading>
        <Text>
          Guardamos os teus dados pessoais durante o tempo necessário para
          cumprir os fins para os quais processamos os teus dados pessoais. Após
          o cancelamento da tua adesão, os teus dados serão mantidos por um
          máximo de 7 anos.
        </Text>
        <Heading size="md">Segurança</Heading>
        <Text>
          Devido à natureza dos nossos serviços e à confiança que deves poder
          depositar em nós, tendo em conta o estado da técnica e os custos de
          implementação, tomamos medidas técnicas e organizativas adequadas para
          garantir que o processamento de dados pessoais ocorre em conformidade
          com o RGPD.
        </Text>
        <Heading size="md">Autoridade de Proteção de Dados</Heading>
        <Text>
          Naturalmente, teremos todo o gosto em ajudar-te se tiveres queixas
          sobre o processamento dos teus dados pessoais. Ao abrigo do RGPD,
          também tens o direito de apresentar uma queixa junto da Autoridade de
          Proteção de Dados contra esse processamento de dados pessoais. Podes
          contactar a Autoridade de Proteção de Dados para esse efeito.
        </Text>
        <Heading size="md">Alterações</Heading>
        <Text>
          O SUP SUP CLUB reserva-se o direito de alterar e modificar a sua
          declaração de privacidade.
        </Text>
        <Text>
          Se tiveres alguma dúvida, contacta-nos em{' '}
          <Link href="mailto:info@supsupclub.com">info@supsupclub.com</Link>.
        </Text>
        <Text>
          Esta declaração de privacidade foi atualizada pela última vez a 1 de
          abril de 2023.
        </Text>
      </Stack>
    </div>
  );
};
